// Základní URL PHP backendu.
// Nastav v .env souboru (viz .env.example), nebo uprav rovnou zde.
const API_BASE = process.env.REACT_APP_API_URL || 'https://admin.hugoknives.cz/backend';

// Client ID pro anonymní upload na Imgur (bez přihlášení uživatele).
// Získáš na https://api.imgur.com/oauth2/addclient (typ "Anonymous usage without user authorization").
const IMGUR_CLIENT_ID = process.env.REACT_APP_IMGUR_CLIENT_ID || '16f2bc8fda9db18';

async function parseJsonSafe(res) {
  const text = await res.text();
  try {
    return JSON.parse(text);
  } catch (e) {
    throw new Error('Server nevrátil platná data (zkontroluj REACT_APP_API_URL).');
  }
}

// "credentials: include" je nutné, aby se s každým požadavkem posílala
// přihlašovací cookie (session) - i mezi různými doménami.

export async function getStatus() {
  const res = await fetch(`${API_BASE}/status.php`, { credentials: 'include' });
  return parseJsonSafe(res);
}

export async function login(password) {
  const res = await fetch(`${API_BASE}/login.php`, {
    method: 'POST',
    credentials: 'include',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ password }),
  });
  return parseJsonSafe(res);
}

export async function logout() {
  const res = await fetch(`${API_BASE}/logout.php`, {
    method: 'POST',
    credentials: 'include',
  });
  return parseJsonSafe(res);
}

// DOČASNÁ VÝVOJÁŘSKÁ FUNKCE
// Přihlásí bez hesla. Tlačítko se v UI zobrazuje jen v lokálním "npm start" buildu
// (viz Login.js), backend endpoint dev-login.php je ale potřeba po dokončení testů
// z produkčního serveru odstranit / zablokovat - viz komentář v backend-example/dev-login.php.
export async function devLogin() {
  const res = await fetch(`${API_BASE}/dev-login.php`, {
    method: 'POST',
    credentials: 'include',
  });
  return parseJsonSafe(res);
}

export async function fetchImages() {
  const res = await fetch(`${API_BASE}/list.php`, { credentials: 'include' });
  return parseJsonSafe(res);
}

export async function deleteImage(name) {
  const res = await fetch(`${API_BASE}/delete.php`, {
    method: 'POST',
    credentials: 'include',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ name }),
  });
  return parseJsonSafe(res);
}

export async function uploadImages(files) {
  const formData = new FormData();
  files.forEach((file) => formData.append('images[]', file));

  const res = await fetch(`${API_BASE}/upload.php`, {
    method: 'POST',
    credentials: 'include',
    body: formData,
  });
  return parseJsonSafe(res);
}

// ---------- Videa ----------

export async function fetchVideos() {
  const res = await fetch(`${API_BASE}/videos-list.php`, { credentials: 'include' });
  return parseJsonSafe(res);
}

export async function addVideo(youtubeId, title) {
  const res = await fetch(`${API_BASE}/videos-add.php`, {
    method: 'POST',
    credentials: 'include',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ youtube_id: youtubeId, title }),
  });
  return parseJsonSafe(res);
}

export async function deleteVideo(id) {
  const res = await fetch(`${API_BASE}/videos-delete.php`, {
    method: 'POST',
    credentials: 'include',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id }),
  });
  return parseJsonSafe(res);
}

// ---------- Volné nože ----------

export async function fetchKnives() {
  const res = await fetch(`${API_BASE}/knives-list.php`, { credentials: 'include' });
  return parseJsonSafe(res);
}

export async function addKnife({ imageUrl, price, description }) {
  const res = await fetch(`${API_BASE}/knives-add.php`, {
    method: 'POST',
    credentials: 'include',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ image_url: imageUrl, price, description }),
  });
  return parseJsonSafe(res);
}

export async function deleteKnife(id) {
  const res = await fetch(`${API_BASE}/knives-delete.php`, {
    method: 'POST',
    credentials: 'include',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id }),
  });
  return parseJsonSafe(res);
}

// Nahraje obrázek přímo na Imgur (bez backendu) a vrátí přímý odkaz na obrázek.
// Metadata (cena, popis) se pak ukládají do naší DB přes addKnife().
export async function uploadToImgur(file) {
  if (!IMGUR_CLIENT_ID) {
    throw new Error('Chybí IMGUR Client ID (nastav REACT_APP_IMGUR_CLIENT_ID v .env).');
  }

  const formData = new FormData();
  formData.append('image', file);

  const res = await fetch('https://api.imgur.com/3/image', {
    method: 'POST',
    headers: { Authorization: `Client-ID ${IMGUR_CLIENT_ID}` },
    body: formData,
  });

  const data = await res.json();
  if (!data.success) {
    throw new Error((data.data && data.data.error) || 'Nahrání na Imgur se nezdařilo.');
  }
  return data.data.link;
}
